module.exports = __webpack_public_path__ + "static/media/fb5.4e25c89f.png";